// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modale de creation de chiffrage : le shell (overlay, carte, form-group, inputs, modal-actions) est
   repris de LancerMarcheModal.css (importe par le composant). Ce fichier ne style QUE la vignette des
   coordonnees transmises a l'acheteur, calquee sur le rendu des cartes titulaires (lmm-card-info).
   Palette fermee : titres #595959, primaire #f97316, texte #374151. Echelle 1rem = 10px. */

.ccm-vignette {
  margin-top: 1.6rem;
  padding: 0 1.6rem 1.6rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.8rem;
  background-color: #ffffff;
}

.ccm-vignette-heading {
  margin: 0;
  font-size: 1.4rem;
  font-weight: 700;
  color: #595959;
  text-align: center;
}

.ccm-vignette-subtitle {
  margin: 0.4rem 0 0;
  font-size: 1.2rem;
  color: #6b7280;
  text-align: center;
}

.ccm-vignette-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.4rem;
  margin-top: 1.4rem;
  text-align: center;
}

.ccm-vignette-nom {
  margin: 0 0 0.4rem;
  font-size: 1.5rem;
  font-weight: 700;
  color: #374151;
}

.ccm-vignette-line {
  margin: 0;
  font-size: 1.3rem;
  color: #374151;
  /* Adresse potentiellement longue : on laisse le texte revenir a la ligne (pas de troncature). */
  overflow-wrap: anywhere;
}

.ccm-vignette-line a {
  color: inherit;
  text-decoration: none;
}

.ccm-vignette-label {
  font-weight: 600;
  color: #6b7280;
  margin-right: 0.3rem;
}

.ccm-vignette-line--contact {
  margin-top: 0.5rem;
  font-weight: 600;
}

/* La banniere info s'aligne sur la largeur de la vignette, detachee du bloc coordonnees. */
.ccm-vignette-banner {
  margin-top: 1.4rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Chiffrage/components/ChiffrageCreateModal.css"],"names":[],"mappings":"AAAA;;;2FAG2F;;AAE3F;EACE,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,gGAAgG;EAChG,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,2FAA2F;AAC3F;EACE,kBAAkB;AACpB","sourcesContent":["/* Modale de creation de chiffrage : le shell (overlay, carte, form-group, inputs, modal-actions) est\n   repris de LancerMarcheModal.css (importe par le composant). Ce fichier ne style QUE la vignette des\n   coordonnees transmises a l'acheteur, calquee sur le rendu des cartes titulaires (lmm-card-info).\n   Palette fermee : titres #595959, primaire #f97316, texte #374151. Echelle 1rem = 10px. */\n\n.ccm-vignette {\n  margin-top: 1.6rem;\n  padding: 0 1.6rem 1.6rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.8rem;\n  background-color: #ffffff;\n}\n\n.ccm-vignette-heading {\n  margin: 0;\n  font-size: 1.4rem;\n  font-weight: 700;\n  color: #595959;\n  text-align: center;\n}\n\n.ccm-vignette-subtitle {\n  margin: 0.4rem 0 0;\n  font-size: 1.2rem;\n  color: #6b7280;\n  text-align: center;\n}\n\n.ccm-vignette-body {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.4rem;\n  margin-top: 1.4rem;\n  text-align: center;\n}\n\n.ccm-vignette-nom {\n  margin: 0 0 0.4rem;\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #374151;\n}\n\n.ccm-vignette-line {\n  margin: 0;\n  font-size: 1.3rem;\n  color: #374151;\n  /* Adresse potentiellement longue : on laisse le texte revenir a la ligne (pas de troncature). */\n  overflow-wrap: anywhere;\n}\n\n.ccm-vignette-line a {\n  color: inherit;\n  text-decoration: none;\n}\n\n.ccm-vignette-label {\n  font-weight: 600;\n  color: #6b7280;\n  margin-right: 0.3rem;\n}\n\n.ccm-vignette-line--contact {\n  margin-top: 0.5rem;\n  font-weight: 600;\n}\n\n/* La banniere info s'aligne sur la largeur de la vignette, detachee du bloc coordonnees. */\n.ccm-vignette-banner {\n  margin-top: 1.4rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
